module.exports = __webpack_public_path__ + "b81499807e67a88c4633a6b8c7aa49a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/camscreen3.jpg
// module id = 168
// module chunks = 0